const PaginationConst = {
    FirstPage: 1,
    DefaultPageSize: 10
}

export default PaginationConst;